module.exports = "//docs.gtimg.com/slide/img/_/node_modules/@tencent/docs-design-resources/icon/desktop/svg/text_imagevariant_halfimage_contact_44-6a1bc6.svg";